import React, { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth.jsx";
import api from "@/lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ChangePasswordModal() {
  const { user, refresh } = useAuth();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (user?.must_reset) setOpen(true);
  }, [user]);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password updated");
      await refresh();
      setOpen(false);
    } catch (e2) {
      toast.error(e2?.response?.data?.detail || "Failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-orange-100 text-orange-600 flex items-center justify-center"><KeyRound className="w-5 h-5" /></div>
          <div>
            <div className="font-display font-black text-xl">Set your password</div>
            <div className="text-xs text-slate-500">First login — please set a new password.</div>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <input type="password" required value={cur} onChange={(e) => setCur(e.target.value)} placeholder="Current (temp) password" className="input-pill" data-testid="cp-current" />
          <input type="password" required minLength={6} value={nw} onChange={(e) => setNw(e.target.value)} placeholder="New password (min 6 chars)" className="input-pill" data-testid="cp-new" />
          <button type="submit" disabled={busy} className="btn-primary w-full py-3" data-testid="cp-submit">{busy ? "Saving…" : "Update password"}</button>
        </form>
      </div>
    </div>
  );
}
